export class DenouncedGender {
    get id() {
        return this.denouncedGenderState.id;
    }
    get diligenceNumber() {
        return this.denouncedGenderState.diligenceNumber;
    }
    get denouncedThirId() {
        return this.denouncedGenderState.denouncedThirId;
    }
    get userId() {
        return this.denouncedGenderState.userId;
    }
    get criminalRecord() {
        return this.denouncedGenderState.criminalRecord;
    }
    get profesionId() {
        return this.denouncedGenderState.profesionId;
    }
    get employmentSituation() {
        return this.denouncedGenderState.employmentSituation;
    }
    get workplaceId() {
        return this.denouncedGenderState.workplaceId;
    }
    get economicSituation() {
        return this.denouncedGenderState.economicSituation;
    }
    get familyResponsibilities() {
        return this.denouncedGenderState.familyResponsibilities;
    }
    get temperament() {
        return this.denouncedGenderState.temperament;
    }
    get healthStatus() {
        return this.denouncedGenderState.healthStatus;
    }
    get addictions() {
        return this.denouncedGenderState.addictions;
    }
    get frequentPlaces() {
        return this.denouncedGenderState.frequentPlaces;
    }
    get vehicles() {
        return this.denouncedGenderState.vehicles;
    }
    set denouncedThirId(denouncedThirId) {
        this.denouncedGenderState.denouncedThirId = denouncedThirId;
    }
    constructor(denouncedGenderState) {
        this.denouncedGenderState = denouncedGenderState;
    }
    getState() {
        return this.denouncedGenderState;
    }
}
